import DataLayer from '../dataLayer'

export default class FooterTracker {


    constructor() {
        this.analytics = window.__pt.fn.analytics;
        this.settings = window.__pt.settings;
        this.events = window.__pt.fn.analytics.events;
    }

    clickLink(title) {

        const data = {
            content_type: this.events.link,
            element: title,
            event: this.events.trackEvent,
            eventName: this.events.selectContent,
            layer: this.settings.page
        }

        this.analytics.set(data.event, data);
    }

    selectContent(btn, text) {
        const data = {
            content_type: this.events.button,
            element: `${btn} :: ${text}`,
            event: this.events.trackEvent,
            eventName: this.events.selectContent,
            layer: this.settings.page
        }
        this.analytics.set(data.event, data);
    }

}
